import http from "../http-common";
class PatientDataService {
  showConfirm(plann,drdv) {
    return http.get(`/patient/showconfirm?plann=${plann}&drdv=${drdv}`);
  }
  nomPatient(email) {
    return http.get(`/patient/nompatient?email=${email}`);
  }
  canceledRdv(plan,email) {
    return http.get(`/patient/canceledrdv?plan=${plan}&email=${email}`);
  }
  patrdv(email) {
    return http.get(`/patient/patrdv?email=${email}`);
  }
  patientRdvCancel(email,idrdv) {
    return http.put(`/patient/patientrdvcancel?email=${email}&idrdv=${idrdv}`);
  }
  simulatePayment(payload) {
    return http.post(`/patient/payment/simulate`, payload);
  }
  confirmRdvAfterPayment(payload) {
    return http.post(`/patient/rdv/confirm`, payload);
  }
}
export default new PatientDataService();